const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

export const normalizeLoginCredentials = (credentials) => ({
  company_code: String(credentials.company_code ?? "").trim(),
  employee_code: String(credentials.employee_code ?? "").trim(),
  password: credentials.password,
});

// Login establishes a session from the submitted credentials. It must not use
// cookies or bearer tokens from a previous session, or enter the API retry loop.
export const requestLogin = async (credentials) => {
  const payload = normalizeLoginCredentials(credentials);
  if (!payload.company_code || !payload.employee_code || !payload.password) {
    throw new Error("Please enter company code, employee code, and password.");
  }

  const response = await fetch(`${API_BASE}/auth/login`, {
    method: "POST",
    credentials: "omit",
    cache: "no-store",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(payload),
  });

  const result = await response.json();
  if (!response.ok || !result.status) {
    const error = new Error(result.message || "Login failed");
    error.status = response.status;
    error.responseData = result;
    throw error;
  }
  if (!result.access_token || !result.data?.user_id || !result.data?.company_id) {
    throw new Error("Login returned incomplete session information. Please try again.");
  }
  return result;
};
